import { Link } from '@tanstack/react-router';
import { HelpCircle } from 'lucide-react';
import type { JSX } from 'react';

export interface GuideLinkProps {
  moduleId: string;
  /** Optional anchor inside the module page: `'steps' | 'states' | 'faq' | 'tips'`. */
  section?: string;
  /** Visible text. When absent, the icon carries `aria-label="Ver guía"` instead. */
  label?: string;
}

export function GuideLink({ moduleId, section, label }: GuideLinkProps): JSX.Element {
  return (
    <Link
      to="/guia/$moduleId"
      params={{ moduleId }}
      {...(section === undefined ? {} : { hash: section })}
      className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-500 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-700"
      aria-label={label === undefined ? 'Ver guía' : undefined}
      title="Ver guía"
    >
      <HelpCircle aria-hidden="true" className="size-[18px]" />
      {label === undefined ? null : <span>{label}</span>}
    </Link>
  );
}
